<template>
  <div v-if="file" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70 p-6" @click.self="$emit('close')">
    <div class="bg-white rounded-lg shadow-xl w-full max-w-3xl max-h-full flex flex-col overflow-hidden">
      <div class="flex items-center justify-between px-4 py-3 border-b">
        <span class="text-sm font-medium truncate pr-4">{{ file.name }}</span>
        <button type="button" class="text-gray-500 hover:text-gray-800 text-xl leading-none" @click="$emit('close')">✕</button>
      </div>
      <div class="flex-1 overflow-auto bg-gray-100 flex items-center justify-center p-4">
        <img v-if="isImage" :src="url" :alt="file.name" class="max-w-full max-h-[75vh] mx-auto" />
        <iframe v-else-if="isPdf" :src="url" class="w-full h-[75vh]" />
      </div>
    </div>
  </div>
</template>

<script>
const IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg']

export default {
  props: {
    file: { type: Object, default: null },
  },
  emits: ['close'],
  computed: {
    extension() {
      if (!this.file || !this.file.name) return ''
      return this.file.name.split('.').pop().toLowerCase()
    },
    isImage() {
      return IMAGE_EXTENSIONS.includes(this.extension)
    },
    isPdf() {
      return this.extension === 'pdf'
    },
    url() {
      if (!this.file) return ''
      return window.location.origin + '/files/' + this.file.path
    },
  },
}
</script>

<style scoped>
.z-50 {
  z-index: 50;
}
</style>
